

import TabItem from '@/components/ui/tabs/TabItem.vue';
import Tabs from '@/components/ui/tabs/Tabs.vue';
import { AllLabels } from '@/interfaces';
import { labelsStore } from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import CaseTimeline from './CaseTimeline.vue';

@Component({
  components: {
    CaseTimeline,
    Tabs,
    TabItem
  }
})
export default class CaseTertiaryMetrics extends Vue {

  public get labels(): AllLabels {
    return labelsStore.labels;
  }
}
